
const monthsList = ["មករា", "កុម្ភៈ", "មីនា", "មេសា", "ឧសភា", "មិថុនា", "កក្កដា", "សីហា", "កញ្ញា", "តុលា", "វិច្ឆកា", "ធ្នូ"]
// const monthsList = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"]
let get_api = () => {
	let hostname = String(location.hostname);
	if (hostname.includes("oneme-old.traware.com")) return "https://oneme-api-old.traware.com/api/v1";
	if (hostname.includes("admin.oneme-express.com")) return "https://api.oneme-express.com/api/v1";
	if (hostname.includes("admin-dev.oneme-express.com")) return "https://api-dev.oneme-express.com/api/v1";
	return "https://api.oneme-express.com/api/v1";
	// return "http://localhost:81/api/v1";
}

const config = {
	api: get_api(),
	cdn: "https://cdn.oneme-express.com",
	datelify: (timestamp) => {
		let d = new Date(timestamp * 1000);
		let date = d.getDate();
		let month = d.getMonth();
		let year = d.getFullYear();
		let hour = d.getHours();
		let minute = d.getMinutes();

		let state = hour >= 12 ? "PM" : "AM";
		let paddingDate = date > 9 ? "" : "0";
		let paddingMinute = minute > 9 ? "" : "0";

		return `${paddingDate}${date} ${monthsList[month]} ${year} · ${hour}:${paddingMinute}${minute}${state}`
	},
	generate: (length) => {
		let allowedString = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"
		let generated = ""
		for (let i = 0; i < parseInt(length); i++) {
			let random = Math.floor(Math.random() * allowedString.length)
			generated += allowedString[random]
		}

		return String(generated);
	},
	encrypt: (text, key = 7) => {
		return Array.from(text).map(ch => String.fromCharCode(ch.charCodeAt(0) + key)).join('');
	},

	decrypt: (text, key = 7) => {
		return Array.from(text).map(ch => String.fromCharCode(ch.charCodeAt(0) - key)).join('');
	},
	
	get_time_from_date_view: function (date) {
		if (date === null) return null;

		let time = new Date("2001-01-05 " + date);
		time.setMinutes(time.getMinutes() - time.getTimezoneOffset() * 2);

		let time_string = time.toISOString().split("T")[1].slice(0, 5);

		let hour = parseInt(time_string.slice(0, 2));
		let minute = parseInt(time_string.slice(3, 5));
		let state = hour >= 12 ? "PM" : "AM";
		hour = hour > 12 ? hour - 12 : hour;
		let hour_padding = hour > 9 ? "" : "0";
		hour = hour == 0 ? 12 : hour;
		let minute_padding = minute > 9 ? "" : "0";
		return `${hour_padding}${hour}:${minute_padding}${minute} ${state}`;
	},
	orderlify: (number) => {
		let length = String(number).length;
		let padding = 6 - length;
		let zeroPadding = "";
		for (let i = 0; i < padding; i++) {
			zeroPadding += "0";
		}

		return zeroPadding + number;
	},
	timelify: (date) => {
		let oldDate = new Date(date * 1000);
		let currentDate = new Date();

		let seconds = (currentDate.getTime() - oldDate.getTime()) / 1000;

		if (seconds / 31536000 > 1) {
			return Math.floor(seconds / 31536000) + " ឆ្នាំមុន";

		} else if (seconds / 2592000 > 1) {
			return Math.floor(seconds / 2592000) + " ខែមុន";

		} else if (seconds / 86400 > 1) {
			return Math.floor(seconds / 86400) + " ថ្ងៃមុន";

		} else if (seconds / 3600 > 1) {
			return Math.floor(seconds / 3600) + " ម៉ោងមុន";

		} else if (seconds / 60 > 1) {
			return Math.floor(seconds / 60) + " នាទី";

		} else {
			return "ឥឡូវនេះ";
		}
	},

	get_duration: (date) => {
		let oldDate = new Date(date * 1000);
		let currentDate = new Date();

		let seconds = (currentDate.getTime() - oldDate.getTime()) / 1000;

		if (seconds / 31536000 > 1) {
			return Math.floor(seconds / 31536000) + " ឆ្នាំមុន";

		} else if (seconds / 2592000 > 1) {
			return Math.floor(seconds / 2592000) + " ខែមុន";

		} else if (seconds / 86400 > 1) {
			return Math.floor(seconds / 86400) + " ថ្ងៃមុន";

		} else if (seconds / 3600 > 1) {
			return Math.floor(seconds / 3600) + " ម៉ោងមុន";

		} else if (seconds / 60 > 1) {
			return Math.floor(seconds / 60) + " នាទីមុន";

		} else {
			return "ឥឡូវនេះ";
		}

	},
	getDistanceFromLatLonInKm: (lat1, lon1, lat2, lon2) => {
		let R = 6371;
		let dLat = config.deg2rad(lat2 - lat1);
		let dLon = config.deg2rad(lon2 - lon1);
		let a =
			Math.sin(dLat / 2) * Math.sin(dLat / 2) +
			Math.cos(config.deg2rad(lat1)) * Math.cos(config.deg2rad(lat2)) *
			Math.sin(dLon / 2) * Math.sin(dLon / 2)
			;
		let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
		let d = R * c;
		return d;
	},
	deg2rad: (deg) => {
		return deg * (Math.PI / 180)
	},

	getCookie: (cname) => {
		var name = cname + "=";
		var decodedCookie = decodeURIComponent(document.cookie);
		var ca = decodedCookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	},
	moneylify: (total, currency = "usd") => {
		// if (Number.isNaN(total)) total = 0;
		let sign = "", currency_view_front = "", currency_view_end = "";

		if (currency == 'khr') currency_view_front = "", currency_view_end = " ៛";
		if (currency == 'usd') currency_view_front = "$", currency_view_end = "";

		total = parseFloat(total).toFixed(2);

		if (total < 0) {
			sign = "-";
			total = total * -1.00;
		}

		let total_real = String(parseInt(total));
		let total_rational = String((total - parseInt(total)).toFixed(2));
		// console.log()
		let output = "";
		if (total_real.length <= 3) {
			output = total_real;
		} else if (total_real.length <= 6) {
			output = total_real.slice(0, total_real.length - 3) + "," + total_real.slice(total_real.length - 3);
		} else if (total_real.length <= 9) {
			output = total_real.slice(0, total_real.length - 6) + "," + total_real.slice(total_real.length - 6, total_real.length - 3) + "," + total_real.slice(total_real.length - 3);
		} else if (total_real.length <= 12) {
			output = total_real.slice(0, total_real.length - 9) + "," + total_real.slice(total_real.length - 9, total_real.length - 6) + "," + total_real.slice(total_real.length - 6, total_real.length - 3) + "," + total_real.slice(total_real.length - 3);
		} else {
			output = total_real;
		}

		return sign + currency_view_front + output + "." + total_rational.replace("0.", "") + currency_view_end;
	},
	getExpire(timestamp) {

		let currentDay = new Date();

		let left = Math.round((timestamp * 1000 - currentDay.getTime()) / (86400000))

		return {
			value: left < 0 ? "ផុតកំណត់" : "សល់ " + left + " ថ្ងៃ",
			total: left < 0 ? 0 : left
		}
		// if (left < 0) {
		// 	return "ផុតកំណត់";
		// } else {
		// 	return "សល់ " + left + " ថ្ងៃ";
		// }
	},
	base64decode: function (encoded) {
		return new Buffer(encoded, 'base64').toString('utf8')
	},
	discountPrice(price, discount, type) {
		price = parseFloat(price);
		discount = parseFloat(discount);
		let discounted_price;
		if (type == 'p') {
			discounted_price = price - (price * discount / 100);
			discounted_price = discounted_price.toFixed(2);
			return discounted_price;
		} else if (type == 'm') {
			discounted_price = price - discount;
			if (discounted_price < 0) {
				discounted_price = 0;
			}
			return discounted_price;
		} else {
			return price;
		}
	},
	validateUsername(string) {
		let array = String(string).split(" ");
		return array.join("").toLocaleLowerCase().trim();
	},
	getProfileUrl: (id = 'noavailable') => {
		return `https://cdn.oneme-express.com/qr/${id}.jpg`;
	},
	getPackageUrl: (id = 'noavailable') => {
		return `https://cdn.oneme-express.com/package/${id}`;
	},
	getGender(t) {
		if (t == "o") return "ផ្សេងទៀត";
		if (t == "f") return "ស្រី";
		if (t == "m") return "ប្រុស";
		return "Unknown";
	},
	getStatus(s) {
		if (s == "act") return "ដំណើរការ";
		if (s == "pnd") return "កំពុងរង់ចាំ";
		if (s == "pad") return "បានបង់ប្រាក់";
		if (s == "npd") return "មិនទាន់បង់ប្រាក់";
		if (s == "fin") return "បានបញ្ចប់";
		if (s == "nac") return "មិនដំណើរការ";
		if (s == "rcv") return "អ្នកទទួល";
		if (s == "snd") return "អ្នកផ្ញើ";
		if (s == "ndv") return "មិនមានអ្នកដឹក";
		if (s == "wdv") return "រង់ចាំអ្នកដឹក";
		if (s == "dvr") return "កំពុងដឹកជញ្ជូន";
		if (s == "dlv") return "បានដល់អតិថិជន";
		if (s == "rtn") return "បានត្រឡប់";
		if (s == "sl") return "Accountant Administrator";
		if (s == "sa") return "Super Administrator";
		if (s == "ad") return "Operation Administrator";
		if (s == "ca") return "Call Center Administrator";
		if (s == "da") return "Driver Administrator";
		if (s == "ac") return "Accountant";
		if (s == "NODRIVER") return "មិនមានអ្នកទទួល";
		if (s == "PENDING") return "កំពុងទៅទទួល";
		if (s == "COMPLETED") return "បានទៅទទួល";
		if (s == "CANCELED") return "បានបោះបង់";
		if(s == 1) return "អាចស្កេន";
		if(s == 0) return "មិនអាចស្កេន";
		return "មិនមាន";
	}
}


export default config;



// WEBPACK FOOTER //
// ./src/config/config.js